import React, { useState, useEffect } from "react";
import { createBrowserHistory } from "history";
import { Switch, Router, Route } from "react-router-dom";
import { connect } from "react-redux";
import { userFetch, userCulture } from "./redux/actions";
import { MasterKey } from "../src/helpers/Setting";
// Externals
import { Chart } from "react-chartjs-2";
import Notification from "./components/Notification";
// Material helpers
import { ThemeProvider } from "@material-ui/styles";

// ChartJS helpers
import { chartjs } from "./helpers";

// Theme
import theme from "./theme";
import CircularProgress from "./components/Loading";

// Styles
import "react-perfect-scrollbar/dist/css/styles.css";
import "./assets/scss/index.scss";

// Routes
import Routes from "./Routes";

import { Dashboard as DashboardLayout } from "./layouts";
import NotFound from "./views/NotFound";
import RequestSite from "./fetch/auth";
// Browser history
const browserHistory = createBrowserHistory();

// Configure ChartJS
Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
  draw: chartjs.draw
});

const App = props => {
  const [loading, setLoading] = useState(!!props.token);
  const getCultur = () => {
    const body = {
      query: `
      query{
        culture{
          id
          language
          direction
        }
      }
      `
    };
    RequestSite({
      auth: `Bearer ${MasterKey}`,
      body: JSON.stringify(body)
    })
      .then(({ culture }) => {
        props.userCulture(culture);
      })
      .catch(console.log);
  };
  useEffect(() => {
    // setLoading(false);
    if (props.token) {
      props.userFetch({ token: props.token, setLoading });
    }
    //eslint-disable-next-line
    getCultur();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return loading ? (
    <CircularProgress />
  ) : (
    <ThemeProvider theme={theme}>
      <Notification />
      <Router history={browserHistory}>
        <Switch>
          {props.isLogin ? (
            <DashboardLayout>
              {Routes[1].map((router, i) => (
                <Route
                  key={i}
                  path={router.link}
                  render={otherprops => (
                    <router.component
                      {...otherprops}
                      language={props.language}
                    />
                  )}
                  exact
                />
              ))}
            </DashboardLayout>
          ) : (
            Routes[0].map((router, i) => (
              <Route
                key={i}
                path={router.link}
                render={otherprops => (
                  <router.component {...otherprops} language={props.language} />
                )}
                exact
              />
            ))
          )}

          <Route component={NotFound} exact />
        </Switch>
        {/* {props.isLogin && <Redirect to="/dashboard" />} */}
        {/* <Route component={NotFound} /> */}

        {/* {props.isLogin ? (
          <Redirect to="/mybeneficyprofile" />
        ) : (
        )} */}
      </Router>
    </ThemeProvider>
  );
};

const mapStateToProps = state => ({
  isLogin: state.user.isLogin,
  token: state.user.token,
  language: state.language
});

const mapDispatchToProps = {
  userFetch,
  userCulture
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
